import { handleActions } from 'redux-actions';
import * as requestsActions from '../actions/requests';

let requestsState = {
  allRequests: null,
  watchedStat: null,
  allDrivers: null,
  filterRequests: [],
  requestsByProfile: [],
  requestsLoading: false,
  requestsUpdating: false,
  requestById: null,
  successMessage: '',
  errorMessage: '',
  entities: null,
  watchedTypes: null,
  repliedTypes: null,
  pagination: null
};

export const requests = handleActions(
  {
    // watch/unwatch entity
    [requestsActions.watchRequest]: state => {
      return state;
    },
    [requestsActions.watchRequestSuccess]: (state, action) => {
      return {
        ...state,
        allRequests: action.payload.requests,
        watchedStat: action.payload.watchedStat,
      };
    },
    [requestsActions.unwatchRequest]: state => {
      return state;
    },
    [requestsActions.unwatchRequestSuccess]: (state, action) => {
      return {
        ...state,
        allRequests: action.payload.requests,
        watchedStat: action.payload.watchedStat,
      };
    },
    /* // Set View_log
    [requestsActions.setViewLog]: (state, action) => {
      const { payload } = action;
      return payload;
    },
    [requestsActions.setViewLogSuccess]: (state, action) => {
      return {
        ...state,
        allRequests: action.payload.requests,
        watchedStat: action.payload.watchedStat,
      };
    }, */
    // Show filter Results
    [requestsActions.showFilterResults]: state => {
      return {
        ...state,
        allRequests: state.filterRequests,
      };
    },
    //Get Search Requests
    [requestsActions.searchRequests]: state => {
      return { ...state, requestsLoading: true };
    },
    [requestsActions.searchRequestsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allRequests: payload.requests,
        requestTypes: payload.requestTypes,
        watchedStat: payload.watchedStat,
        allRequestsStat: payload.requestsStat,
        allDrivers: payload.drivers,
        requestsLoading: false,
      };
    },
    [requestsActions.searchRequestsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
        requestsLoading: false,
      };
    },
    //Get Requests By Profile
    [requestsActions.getRequestsByProfile]: state => {
      return { ...state, requestsLoading: true };
    },
    [requestsActions.getRequestsByProfileSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        requestsByProfile: payload.data,
        requestsLoading: false,
      };
    },
    [requestsActions.getRequestsByProfileError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
        requestsLoading: false,
      };
    },
    //Get All Requests
    [requestsActions.getAllRequests]: (state, _action) => {
      return { ...state, requestsLoading: true };
    },
    [requestsActions.getAllRequestsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allRequests: payload.requests,
        requestTypes: payload.requestTypes,
        watchedTypes: payload.watchedTypes,
        repliedTypes: payload.repliedTypes,
        watchedStat: payload.watchedStat,
        allDrivers: payload.drivers,
        pagination: payload.pagination,
        requestsLoading: false,
      };
    },
    [requestsActions.getAllRequestsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        requestsLoading: false,
      };
    },
    [requestsActions.getFilterRequests]: state => {
      return { ...state, requestsLoading: true };
    },
    [requestsActions.getFilterRequestsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allRequests: payload.requests,
        pagination: payload.pagination,
        requestsLoading: false,
      };
    },
    [requestsActions.getAllRequestsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        requestsLoading: false,
      };
    },

    [requestsActions.filterRequests]: (state, action) => {
      return state;
    },
    [requestsActions.filterRequestsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterRequests: payload.data,
      };
    },
    [requestsActions.filterRequestsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
      };
    },

    //Get Request
    [requestsActions.getRequest]: (state, _action) => {
      return {...state, loading: true};
    },
    [requestsActions.getRequestSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allRequests: state.allRequests,
        requestById: payload.data,
        loading: false
      };
    },
    [requestsActions.getRequestError]: (_state, action) => {
      return console.error('Ошибка в GetRequestByID');
    },
    //Get actual clients
    [requestsActions.getActualClients]: state => {
      return {
        ...state,
        actualClients: [],
        actualClientsLoading: true,
        actualClientsFetchingError: '',
      };
    },
    [requestsActions.getActualClientsSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        actualClients: payload,
        actualClientsLoading: false,
        actualClientsFetchingError: '',
      };
    },
    [requestsActions.getActualClientsError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        actualClients: [],
        actualClientsFetchingError: payload.data.message,
        actualClientsLoading: false,
      };
    },
  },
  requestsState
);
